<template>
  <v-container>
    <div
      class="d-flex flex-row justify-space-around"
      :color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'"
      flat
      tile
    >
      <div class="text-center">
        <span class="text-h5">Currently Available </span>
        <div class="d-flex">
          <v-card class="mx-auto text-center my-4">
            <v-card-text>
              <span class="text-h4"> {{ companyFunds }}</span>
            </v-card-text>
          </v-card>
        </div>
        <div>Licenses</div>
        <AddFundsDialog :companyId="companyId"/>
      </div>
      <div class="text-center">
        <span class="text-h5">Payment History </span>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Date</th>
                <th class="text-left">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in paymentHistory" :key="item.date">
                <td>{{ item.dateStr }}</td>
                <td>{{ item.amount }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
  </v-container>
</template>

<script>
import database from "@/firebase/database";
import AddFundsDialog from "./Components/AddFundsDialog.vue";

export default {
  components: { AddFundsDialog },
  props: ["companyId"],
  data() {
    return {
      paymentHistory: [],
    };
  },
  computed: {
    companyFunds() {
      return Math.floor(
        (this.$store.state.companiesPrivate[this.$props.companyId]?.funds ?? 0) / 10,
      );
    },
  },
  mounted() {
    this.getPaymentHistory();
  },
  watch: {
    companyFunds() {
      this.getPaymentHistory();
    },
  },
  methods: {
    async getPaymentHistory() {
      this.paymentHistory = await database.getPaymentHistory(this.$props.companyId).then(
        (paymentHistory) =>
          // eslint-disable-next-line implicit-arrow-linebreak
          paymentHistory
            .sort((a, b) => (a.date < b.date ? 1 : -1))
            .map((item) => ({
              date: item.date,
              dateStr: new Date(item.date).toLocaleDateString(),
              amount: `$${item.amount / 100}`,
            })),
        // eslint-disable-next-line function-paren-newline
      );
    },
  },
};
</script>

<style >
#amountfield {
  transform: scale(2);
  transform-origin: center;
}
</style>
